<template>
  <layout-vertical>
    <div v-if="['index', 'search-users', 'new-users', 'popular-users', 'video-call-users', 'for-you', 'near-by', 'online-users', 'moments'].includes($route.name)">
      <Paywall1
        v-if="false && showPaywall1"
        :campaign="campaign"
        @close="showPaywall1 = false"
      />

      <paywall-boost-modal
        :profile-image="userProfileImage"
        :user-name="username"
        :modal-model="modalBoostFlow"
        :show-modal-data="modalBoostFlowData"
        @update:modalModel="modalBoostFlow = $event"
      />

      <paywall-modal2
        :modal-model="modalFlow2"
        :modal-data="modalFlow2Data"
        @update:modalModel="modalFlow2 = $event"
      />

      <Paywall2
        v-if="productData && showPaywall"
        :name="paywallName"
        :product="productData"
        :remaining_counter="paywallRemainingCounter"
        :video="paywallVideo"
        @close="showPaywall = false"
      />

      <div v-if="!['chat'].includes($route.name)">
        <div class="row justify-content-center">
          <div class="col-sm-12 col-md-8 col-lg-6 d-flex justify-content-center">
            <div class="carousel-outer">
              <b-carousel
                v-if="$route.name !== 'moments' && ((campaign && campaign.campaignType !== 'ONE_TIME_OFFER' && campaign.campaignHeader) || (Array.isArray(banner1) && banner1.length > 0) || (Array.isArray(bannerPremium) && bannerPremium.length > 0) || (Array.isArray(bannerWithUser1) && bannerWithUser1.length > 0) || (Array.isArray(bannerChat) && bannerChat.length > 0))"
                id="banner-carousel"
                v-model="bannerSlide"
                :interval="7000"
                controls
                no-hover-pause
                style="margin-bottom: 12px;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <div v-if="campaign && campaign.campaignType !== 'ONE_TIME_OFFER' && campaign.campaignHeader">
                  <b-carousel-slide>
                    <template #default>
                      <router-link
                        v-if="campaign.webProduct"
                        class="p-relative campaign-banner-container"
                        :to="{name: 'buy', params: {productId: campaign.webProduct, purchaseSource: 'web_banner'}, query: {campaignId: campaign.campaignId, campaignType: campaign.campaignType}}"
                      >
                        <div class="campaign-banner">
                          <span
                            v-if="campaign.campaignType === 'ONE_TIME_OFFER' && campaignCounter"
                            class="banner-counter"
                          >
                            <feather-icon
                              icon="ClockIcon"
                              size="9"
                            />
                            <span v-if="campaignCounter.hours != '00'">
                              {{ campaignCounter.hours }}:{{ campaignCounter.minutes }}:{{ campaignCounter.seconds }}
                            </span>
                            <span v-else>
                              {{ campaignCounter.minutes }}:{{ campaignCounter.seconds }}
                            </span>
                          </span>
                          <p>
                            {{ campaign.campaignHeader }}
                          </p>
                          <p v-if="campaign.campaignText">
                            {{ campaign.campaignText }}
                          </p>
                          <router-link
                            v-if="campaign.webProduct"
                            :to="{name: 'buy', params: { productId: campaign.webProduct, purchaseSource: 'offer-1' }, query: {campaignId: campaign.campaignId, campaignType: campaign.campaignType}}"
                          >
                            <b-button
                              v-if="userCountry !== 'TR'"
                              class="btn-primary2"
                              style="min-width: 120px"
                            >
                              {{ campaign.amount }}$
                            </b-button>
                            <b-button
                              v-else
                              class="btn-primary2"
                              style="min-width: 120px"
                            >
                              {{ campaign.amount }}&#8378;
                            </b-button>
                          </router-link>
                          <router-link
                            v-else
                            :to="{ name: 'market', params: { purchaseSource: 'offer-1' }}"
                          >
                            <b-button
                              class="btn-primary2"
                              style="min-width: 120px"
                            >
                              {{ $t('Market') }}
                            </b-button>
                          </router-link>
                        </div>
                      </router-link>
                    </template>
                  </b-carousel-slide>
                </div>
                <div v-if="Array.isArray(bannerWithUser1) && bannerWithUser1.length > 0">
                  <div
                    v-for="(banner, i) in bannerWithUser1"
                    :key="i"
                  >
                    <b-carousel-slide>
                      <template #default>
                        <div class="p-relative new-paywall1-container">
                          <div
                            v-if="banner.remainingCounter || banner.paywallCounter"
                            class="new-paywall1-counter"
                          >
                            {{ convertTimeString(banner.remainingCounter || banner.paywallCounter) }}
                            <div style="position:absolute; right: -10px; top: -4px;">
                              <img
                                src="@/assets/images/paywall/half-star-1.svg"
                                alt="half star"
                                width="24"
                              >
                            </div>
                          </div>
                          <div class="new-paywall1">
                            <div style="position:absolute; left: -11px; top: -11px;">
                              <img
                                src="@/assets/images/paywall/half-star-1.svg"
                                alt="half star"
                                width="36"
                              >
                            </div>
                            <div style="position:absolute; right: 10px; bottom: 10px;">
                              <img
                                  src="@/assets/images/paywall/half-star-1.svg"
                                  alt="half star"
                                  width="20"
                              >
                            </div>
                            <div style="position:absolute; right: 0; top: -4px;">
                              <img
                                  src="@/assets/images/paywall/half-stars-1.svg"
                                  alt="half stars"
                                  width="48"
                              >
                            </div>
                            <div style="position: relative">
                              <div style="position:absolute; left: -1px; bottom: 12px; z-index: 3; transform: rotate(75deg)">
                                <img
                                    src="@/assets/images/paywall/diamond-1.svg"
                                    alt="diamond"
                                    width="12"
                                >
                              </div>
                              <div style="position:absolute; right: -1px; top: 12px; z-index: 3; transform: rotate(75deg)">
                                <img
                                    src="@/assets/images/paywall/diamond-1.svg"
                                    alt="diamond"
                                    width="12"
                                >
                              </div>
                              <div style="position:absolute; left: -6px; top: 16px; z-index: 3">
                                <img
                                    src="@/assets/images/paywall/diamond-1.svg"
                                    alt="diamond"
                                    width="20"
                                >
                              </div>
                              <div style="position:absolute; right: -6px; bottom: 20px; z-index: 3; transform: rotate(60deg)">
                                <img
                                    src="@/assets/images/paywall/diamond-1.svg"
                                    alt="diamond"
                                    width="16"
                                >
                              </div>
                              <b-avatar
                                  v-if="banner.bannerProfileImage"
                                  size="88"
                                  :src="banner.bannerProfileImage"
                              />
                            </div>
                            <router-link v-if="false" :to="{name: 'campaigns'}" style="position:absolute; right: 10px; bottom: 10px; font-size: 12px; font-weight: bold; color: #FFDB6C;">
                              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L4 4L7 1M1 4L4 7L7 4" stroke="#FFDA6C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              {{ $t('See All') }}!
                            </router-link>
                            <div class="d-flex flex-column align-items-center justify-content-between h-100">
                              <div>
                                <p style="color: #FFE61A">
                                  {{ banner.bannerHeader }}
                                </p>
                                <p>
                                  {{ banner.bannerText }}
                                </p>
                              </div>
                              <router-link
                                  v-if="banner.webProduct && banner.bannerAction === 'product'"
                                  :to="{name: 'buy', params: {productId: banner.webProduct, purchaseSource: 'banner-with-user-1'}, query: {campaignId: banner.campaignId, campaignType: banner.campaignType}}">
                                <div
                                    class="new-paywall1-button"
                                    style="min-width: 120px"
                                >
                                  {{ banner.bannerButtonText }}
                                </div>
                              </router-link>
                              <div
                                  v-else-if="banner.bannerAction === 'popup'"
                                  class="new-paywall1-button cursor-pointer"
                                  style="min-width: 120px"
                                  @click="openPopup(banner)"
                              >
                                {{ banner.bannerButtonText }}
                              </div>
                              <router-link
                                  v-else
                                  :to="{name: 'market'}"
                              >
                                <div
                                    class="new-paywall1-button"
                                    style="min-width: 120px"
                                >
                                  {{ banner.bannerButtonText }}
                                </div>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </template>
                    </b-carousel-slide>
                  </div>
                </div>
                <div v-if="Array.isArray(bannerPremium) && bannerPremium.length > 0">
                  <div
                      v-for="(banner, i) in bannerPremium"
                      :key="i"
                  >
                    <b-carousel-slide>
                      <template #default>
                        <div class="p-relative new-paywall2-container">
                          <div class="new-paywall2">
                            <div style="position:absolute; left: -6px; top: -5px; transform: rotate(32deg)">
                              <img
                                  src="@/assets/images/paywall/diamond-1.svg"
                                  alt="half star"
                                  width="20"
                              >
                            </div>
                            <div style="position:absolute; right: 10px; bottom: 10px;">
                              <img
                                  src="@/assets/images/paywall/half-star-1.svg"
                                  alt="half star"
                                  width="20"
                              >
                            </div>
                            <div style="position:absolute; right: 0; top: -4px;">
                              <img
                                  src="@/assets/images/paywall/half-stars-1.svg"
                                  alt="half stars"
                                  width="48"
                              >
                            </div>
                            <div style="position: relative; margin-left: -10px">
                              <div style="position:absolute; right: -24px; top: 2px; z-index: 3; transform: rotate(2deg)">
                                <img
                                    src="@/assets/images/paywall/diamond-1.svg"
                                    alt="diamond"
                                    width="22"
                                >
                              </div>
                              <div style="position:absolute; right: -36px; top: 32px; z-index: 3; transform: rotate(32deg)">
                                <img
                                    src="@/assets/images/paywall/diamond-1.svg"
                                    alt="diamond"
                                    width="14"
                                >
                              </div>
                              <div style="position:absolute; right: -28px; bottom: 2px; z-index: 3; transform: rotate(74deg)">
                                <img
                                    src="@/assets/images/paywall/diamond-1.svg"
                                    alt="diamond"
                                    width="22"
                                >
                              </div>
                              <div style="position:absolute; right: -23px; bottom: -10px; z-index: 0;">
                                <img
                                    src="@/assets/images/paywall/profile-bg.png"
                                    alt="bg"
                                    width="116"
                                >
                              </div>
                              <b-avatar
                                  v-if="userProfileImage"
                                  size="80"
                                  :src="userProfileImage"
                                  class="mt-1"
                              />
                            </div>
                            <router-link v-if="false" :to="{name: 'campaigns'}" style="position:absolute; right: 10px; bottom: 10px; font-size: 12px; font-weight: bold; color: #FFDB6C;">
                              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L4 4L7 1M1 4L4 7L7 4" stroke="#FFDA6C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              {{ $t('See All') }}!
                            </router-link>
                            <div class="d-flex flex-column align-items-center justify-content-between w-100 h-100 pr-2">
                              <div class="d-flex flex-column align-items-center justify-content-between">
                                <p>
                                  {{ banner.bannerHeader }}
                                </p>
                                <p>
                                  {{ banner.bannerText }}
                                </p>
                              </div>
                              <router-link
                                  v-if="banner.webProduct && banner.bannerAction === 'product'"
                                  :to="{name: 'buy', params: {productId: banner.webProduct, purchaseSource: 'banner-premium'}, query: {campaignId: banner.campaignId, campaignType: banner.campaignType}}"
                              >
                                <div
                                    class="new-paywall2-button"
                                    style="min-width: 120px"
                                >
                                  {{ banner.bannerButtonText }}
                                </div>
                              </router-link>
                              <div
                                  v-else-if="banner.bannerAction === 'popup'"
                                  class="new-paywall2-button cursor-pointer"
                                  style="min-width: 120px"
                                  @click="openPopup(banner)"
                              >
                                {{ banner.bannerButtonText }}
                              </div>
                              <router-link
                                  v-else
                                  :to="{name: 'market'}"
                              >
                                <div
                                    class="new-paywall2-button"
                                    style="min-width: 120px"
                                >
                                  {{ banner.bannerButtonText }}
                                </div>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </template>
                    </b-carousel-slide>
                  </div>
                </div>
                <div v-if="Array.isArray(banner1) && banner1.length > 0">
                  <div
                      v-for="(banner, i) in banner1"
                      :key="i"
                  >
                    <b-carousel-slide>
                      <template #default>
                        <div class="p-relative new-paywall3-container">
                          <div
                              v-if="banner.remainingCounter || banner.paywallCounter"
                              class="new-paywall3-counter"
                          >
                            {{ convertTimeString(banner.remainingCounter || banner.paywallCounter) }}
                          </div>
                          <div class="new-paywall3">
                            <div style="position:absolute; right: 4px; bottom: 32px;">
                              <img
                                  src="@/assets/images/paywall/half-star-1.svg"
                                  alt="half star"
                                  width="18"
                              >
                            </div>
                            <div style="position:absolute; right: 0; top: -4px;">
                              <img
                                  src="@/assets/images/paywall/half-stars-1.svg"
                                  alt="half stars"
                                  width="48"
                              >
                            </div>
                            <div style="position:absolute; left: -6px; top: -12px; z-index: 1;">
                              <img
                                  src="@/assets/images/paywall/paywall3-left.png"
                                  width="136"
                              />
                            </div>
                            <router-link v-if="false" :to="{name: 'campaigns'}" style="position:absolute; right: 10px; bottom: 10px; font-size: 12px; font-weight: bold; color: #FFDB6C;">
                              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L4 4L7 1M1 4L4 7L7 4" stroke="#FFDA6C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              {{ $t('See All') }}!
                            </router-link>
                            <div
                              class="d-flex flex-column align-items-center justify-content-center h-100 gap-6"
                              style="margin-left: 90px; width: calc(100% - 130px)"
                            >
                              <div>
                                <p class="text-center">
                                  {{ banner.bannerHeader }}
                                </p>
                              </div>
                              <router-link
                                  v-if="banner.webProduct && banner.bannerAction === 'product'"
                                  :to="{name: 'buy', params: {productId: banner.webProduct, purchaseSource: 'banner-1'}, query: {campaignId: banner.campaignId, campaignType: banner.campaignType}}"
                              >
                                <div
                                    class="new-paywall3-button"
                                    style="min-width: 120px"
                                >
                                  {{ banner.bannerButtonText }}
                                </div>
                              </router-link>
                              <router-link v-else :to="{name: 'market'}">
                                <div
                                    class="new-paywall3-button"
                                    style="min-width: 120px"
                                >
                                  {{ banner.bannerButtonText }}
                                </div>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </template>
                    </b-carousel-slide>
                  </div>
                </div>
                <div v-if="Array.isArray(bannerChat) && bannerChat.length > 0">
                  <div
                      v-for="(banner, i) in bannerChat"
                      :key="i"
                  >
                    <b-carousel-slide>
                      <template #default>
                        <div class="p-relative new-paywall4-container">
                          <div
                              v-if="banner.remainingCounter || banner.paywallCounter"
                              class="new-paywall4-counter"
                          >
                            {{ convertTimeString(banner.remainingCounter || banner.paywallCounter) }}
                          </div>
                          <div class="new-paywall4">
                            <div style="position:absolute; right: 10px; bottom: 10px;">
                              <img
                                  src="@/assets/images/paywall/half-star-1.svg"
                                  alt="half star"
                                  width="20"
                              >
                            </div>
                            <div style="position:absolute; right: 0; top: -4px;">
                              <img
                                  src="@/assets/images/paywall/half-stars-1.svg"
                                  alt="half stars"
                                  width="48"
                              >
                            </div>
                            <div style="position: relative; margin-left: -26px; margin-top: -24px">
                              <div style="position:absolute; left: 8px; bottom: 2px; z-index: 3;">
                                <img
                                    src="@/assets/images/paywall/half-star-1.svg"
                                    alt="diamond"
                                    width="22"
                                >
                              </div>
                              <div style="position:absolute; right: 8px; top: 4px; z-index: 3;">
                                <img
                                    src="@/assets/images/paywall/half-star-1.svg"
                                    alt="diamond"
                                    width="16"
                                >
                              </div>
                              <div style="position:absolute; right: -6px; bottom: 10px; z-index: 3;">
                                <img
                                  src="@/assets/images/paywall/half-star-1.svg"
                                  alt="diamond"
                                  width="12"
                                >
                              </div>
                              <img
                                src="@/assets/images/paywall/message-icon.png"
                                width="110"
                              />
                            </div>
                            <router-link v-if="false" :to="{name: 'campaigns'}" style="position:absolute; right: 10px; bottom: 10px; font-size: 12px; font-weight: bold; color: #FFDB6C;">
                              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L4 4L7 1M1 4L4 7L7 4" stroke="#FFDA6C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              {{ $t('See All') }}!
                            </router-link>
                            <div
                              class="d-flex flex-column align-items-center justify-content-center h-100"
                              style="gap: 6px;"
                            >
                              <div>
                                <p>
                                  {{ banner.bannerHeader }}
                                </p>
                              </div>
                              <router-link
                                :to="{name: 'chat'}"
                                class="d-flex flex-column justify-content-center align-items-center"
                              >
                                <div class="new-paywall4-button-top">
                                  {{ banner.bannerText }}
                                </div>
                                <div
                                  class="new-paywall4-button"
                                  style="min-width: 120px"
                                >
                                  {{ banner.bannerButtonText }}
                                </div>
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </template>
                    </b-carousel-slide>
                  </div>
                </div>
              </b-carousel>
            </div>
          </div>
        </div>

        <!-- Add Main Screen -->
        <div
          v-if="false && !pwaFirstSetup && isMobile && isSafari && !['chat', 'market', 'buy', 'payment.finalize'].includes($route.name)"
          class="add-main-screen"
        >
          <p>
            {{ $t('Add main screen') }},
          </p>
          <p>
            {{ $t('Add Main Screen Text') }}
          </p>
          <button @click="modalAddMainScreen = true" class="btn-primary2">
            {{ $t('Click') }} & {{ $t('Add') }}
          </button>
        </div>

        <b-modal
          v-model="modalAddMainScreen"
          centered
          hide-footer
          size="sm"
        >
          <div class="instructions">
            <div class="instruction-top">
              <p class="title" v-html="$t('How Do I Add Boho to My Home Screen?')" />
              <b-img :src="instructionImage1" />
              <p class="mb-1">
                1 - {{ $t('Press the share button') }}.
              </p>
            </div>
            <div class="instruction-bottom">
              <div>
                <b-img :src="instructionImage2" />
                <b-img :src="instructionImage4" style="margin-top: 24px;" />
                <p>
                  2 - {{ $t('scroll down, press the ‘’Add to Home Screen Button’’') }}
                </p>
              </div>
              <div>
                <b-img :src="instructionImage3" />
                <b-img :src="instructionImage5" style="width: 48px !important;" />
                <p>
                  3 - {{ $t('Press the ‘’Add button’’') }}
                </p>
              </div>
            </div>
          </div>
        </b-modal>

        <b-modal
          v-model="modalCongrats"
          centered
          hide-footer
          hide-header
          hide-header-close
          body-class="congrats-modal"
          size="sm"
        >
          <div class="congrats">
            <h4>
              {{ $t('Congratulations! you won 250 Diamonds.') }}
            </h4>
            <button
              class="btn-primary2"
              @click="modalCongrats = false"
            >
              {{ $t('Start the Fun!') }}!
            </button>
          </div>
        </b-modal>
        <!-- Add Main Screen -->

        <router-view />
      </div>

      <router-view v-else />
    </div>

    <router-view v-else />

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'
import useJwt from '@/auth/jwt/useJwt'
import {
  BAvatar, BButton, BCarousel, BCarouselSlide, BImg, BModal,
} from 'bootstrap-vue'
import { browserDetector, osDetector } from '@/mixins'
import Paywall1 from '@/components/paywall/p1.vue'
import Paywall2 from '@/components/paywall/p2.vue'
import PaywallModal2 from '@/components/PaywallModal2.vue'
import PaywallBoostModal from '@/components/PaywallBoostModal.vue'

const paywallVideo = require('@/assets/videos/p2/video1.mp4')

export default {
  components: {
    BCarousel,
    BCarouselSlide,
    BAvatar,
    BModal,
    BImg,
    BButton,

    PaywallModal2,
    PaywallBoostModal,

    AppCustomizer,
    LayoutVertical,

    Paywall1,
    Paywall2,
  },
  mixins: [browserDetector, osDetector],
  data() {
    return {
      bannerChat: null,
      bannerWithUser1: null,
      bannerPremium: null,
      banner1: null,
      bannerSlide: 0,
      campaignCounter: null,
      campaignCounterInterval: null,
      campaignCounterSeconds: 0,
      isMobile: false,
      isSafari: false,
      loading: false,
      modalAddMainScreen: false,
      modalCongrats: false,
      modalMessageCompleted: true,
      modalFlow2: false,
      modalFlow2Data: null,
      modalBoostFlow: false,
      modalBoostFlowData: null,
      paywallName: 'p2',
      paywallRemainingCounter: null,
      paywallVideo,
      productData: null,
      pwaFirstSetup: true,
      showCustomizer: $themeConfig.layout.customizer,
      showPaywall: false,
      showPaywall1: false,
      sliding: false,
    }
  },
  computed: {
    campaigns() {
      return this.$store.getters['app/campaigns']
    },
    campaign() {
      const campaign = this.$store.getters['app/campaign']

      if (campaign && campaign.campaignType === 'ONE_TIME_OFFER') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showPaywall1 = true
      }

      return campaign
    },
    chatConnection() {
      return this.$store.getters['socket/chatConnection']
    },
    instructionImage1() {
      if (this.$i18n.locale === 'tr') {
        // eslint-disable-next-line global-require
        return require('@/assets/images/add-main-screen/1-tr.jpg')
      }
      // eslint-disable-next-line global-require
      return require('@/assets/images/add-main-screen/1-en.jpg')
    },
    instructionImage2() {
      if (this.$i18n.locale === 'tr') {
        // eslint-disable-next-line global-require
        return require('@/assets/images/add-main-screen/2-tr.jpg')
      }
      // eslint-disable-next-line global-require
      return require('@/assets/images/add-main-screen/2-en.jpg')
    },
    instructionImage3() {
      if (this.$i18n.locale === 'tr') {
        // eslint-disable-next-line global-require
        return require('@/assets/images/add-main-screen/3-tr.jpg')
      }
      // eslint-disable-next-line global-require
      return require('@/assets/images/add-main-screen/3-en.jpg')
    },
    instructionImage4() {
      if (this.$i18n.locale === 'tr') {
        // eslint-disable-next-line global-require
        return require('@/assets/images/add-main-screen/4-tr.jpg')
      }
      // eslint-disable-next-line global-require
      return require('@/assets/images/add-main-screen/4-en.jpg')
    },
    instructionImage5() {
      if (this.$i18n.locale === 'tr') {
        // eslint-disable-next-line global-require
        return require('@/assets/images/add-main-screen/5-tr.jpg')
      }
      // eslint-disable-next-line global-require
      return require('@/assets/images/add-main-screen/5-en.jpg')
    },
    modalCall: {
      get() {
        return this.$store.getters['app/getModalCall']
      },
      set: value => {
        this.$store.dispatch('app/setModalCall', value)
      },
    },
    modalCallUser() {
      return this.$store.getters['app/getModalCallUser']
    },
    userCountry() {
      return this.$store.getters['auth/userCountry']
    },
    username() {
      return this.$store.getters['auth/userName']
    },
    userProfileImage() {
      return this.$store.getters['auth/profileImage']
    },
  },
  watch: {
    campaign() {
      if (this.campaign && this.campaign.campaignId) {
        if (['index', 'search-users', 'new-users', 'popular-users', 'video-call-users', 'for-you', 'near-by', 'online-users', 'moments'].includes(this.$route.name)) {
          if (this.campaign.campaignType !== 'ONE_TIME_OFFER' && this.campaign.campaignHeader) {
            useJwt.campaignsDisplayed({ campaignId: this.campaign.campaignId })
          }
        }

        if (this.campaign.campaignType === 'ONE_TIME_OFFER') {
          this.campaignCounter = null

          if (this.campaign.remainingCounter || this.campaign.paywallCounter) {
            this.campaignCounterSeconds = (this.campaign.remainingCounter || this.campaign.paywallCounter) || 0
            this.campaignCounterSeconds *= 60 // Dakika cinsinden döndüğü için 60 ile çarpılıyor

            this.campaignCounterInterval = setInterval(() => {
              if (this.campaignCounterSeconds > 0) {
                this.campaignCounterSeconds -= 1
                const remainingHours = Math.floor(this.campaignCounterSeconds / 3600)
                const remainingMinutes = Math.floor((this.campaignCounterSeconds % 3600) / 60)
                const remainingSeconds = this.campaignCounterSeconds % 60

                this.campaignCounter = {
                  hours: remainingHours < 10 ? `0${remainingHours}` : remainingHours,
                  minutes: remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes,
                  seconds: remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds,
                }
              } else {
                clearInterval(this.campaignCounterInterval)
                this.campaignCounterInterval = null
              }
            }, 1000)
          }
        }
      }
    },
    $route: {
      // eslint-disable-next-line no-unused-vars
      handler(value) {
        this.modalAddMainScreen = false
        this.modalCongrats = false
        this.modalMessageCompleted = true
        this.modalFlow2 = false
        this.modalFlow2Data = null
        this.modalBoostFlow = false
        this.modalBoostFlowData = null
      },
      deep: true,
    },
  },

  created() {
    this.getCampaigns2()

    const { isMobile } = this.os
    const { isSafari } = this.browser

    // Mobile && Safari detection
    this.isMobile = isMobile
    this.isSafari = isSafari

    if (this.isRunningAsInstalledApp()) {
      useJwt.checkPwaFirstSetup()
        .then(response => {
          if (!response.data.body.has_setup) {
            useJwt.pwaFirstSetup()
              .then(() => {
                this.pwaFirstSetup = true
                this.modalCongrats = true
              })
          }
        })
    } else {
      // Check pwa first setup
      this.checkPwaFirstSetup()
    }

    // Soketi dinle - Show modal
    if (this.chatConnection) {
      this.chatConnection.on('showModal', data => {
        const agoraCallUser = this.$store.getters['agora/agoraCallUser']

        // Type is browser and show is dynamic_paywall
        if (!agoraCallUser && data && data.show_type === 'browser' && typeof data.show !== 'undefined' && data.show === 'dynamic_paywall') {
          if (typeof data.file !== 'undefined') {
            if (data.file === '2') {
              this.paywallVideo = require('@/assets/videos/p2/video1.mp4')
            } else if (data.file === '3') {
              this.paywallVideo = require('@/assets/videos/p3/video1.mp4')
            } else if (data.file === '4') {
              this.paywallVideo = require('@/assets/videos/p4/video1.mp4')
            } else {
              this.paywallVideo = null
            }
          } else {
            this.paywallVideo = null
          }
          if (this.paywallVideo && !this.showPaywall) {
            this.productData = data.products
            this.paywallRemainingCounter = data.remaining_counter
            this.paywallName = `p${data.file}`
            if (typeof data.products === 'object') {
              this.showPaywall = true
            }
          }
        }
      })
    }
  },
  methods: {
    closeModal() {
      this.modalCall = false
    },
    call() {
      this.$store.dispatch('app/setModalCallUser', this.modalCallUser)
      this.$store.dispatch('app/setModalCall', true)
      // if (this.modalCallUser) {
      //   if (this.modalCallUser.profile?.callType == 2) {
      //     this.$store.dispatch('app/setModalDownloadMobileApp', true)
      //   } else {
      //     if (!this.$store.getters['auth/userPhoneNumber']) {
      //       this.$store.dispatch('app/setModalAddPhoneNumberShowDiamond', false)
      //       this.$store.dispatch('app/setModalAddPhoneNumber', true)
      //       this.$store.dispatch('app/setVerificationType', 'phone')
      //     } else {
      //       this.loading = true
      //       useJwt.callUser(this.modalCallUser.id)
      //           .then(response => {
      //             showNotify(this.$toast, 'Arama başarılı', 'success')
      //           })
      //           .catch(error => {
      //             const { response } = error
      //             throwDefaultError(this.$toast, error)
      //             if (response && response.data?.header?.error?.errorCode == 215) {
      //               this.$store.dispatch('app/setModalAddPhoneNumberShowDiamond', false)
      //               this.$store.dispatch('app/setModalAddPhoneNumber', true)
      //               this.$store.dispatch('app/setVerificationType', 'phone')
      //             }
      //           })
      //           .finally(() => { this.loading = false })
      //     }
      //   }
      // }
    },
    checkPwaFirstSetup() {
      useJwt.checkPwaFirstSetup()
        .then(response => {
          this.pwaFirstSetup = !!response.data.body.has_setup
        })
    },
    convertTimeString(counter) {
      // Koşul 2: Sayaç 0 veya daha az ise, doğrudan "00:00:00" döndür.
      if (counter <= 0) {
        return '00:00:00'
      }

      // Orijinal hesaplama mantığınızı koruyoruz.
      const remainingDays = Math.floor(counter / (3600 * 24))
      const secondsInLastDay = counter % (3600 * 24)

      const remainingHours = Math.floor(secondsInLastDay / 3600) + (remainingDays * 24)
      const remainingMinutes = Math.floor((secondsInLastDay % 3600) / 60)
      const remainingSeconds = secondsInLastDay % 60

      // Koşul 1: Her bir değeri string'e çevirip, 2 karakter uzunluğunda olana kadar
      // başına '0' ekliyoruz (padStart).
      const formattedHours = String(remainingHours).padStart(2, '0')
      const formattedMinutes = String(remainingMinutes).padStart(2, '0')
      const formattedSeconds = String(remainingSeconds).padStart(2, '0')

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    },
    getCampaigns() {
      useJwt.campaigns()
        .then(response => {
          this.$store.dispatch('app/setCampaigns', response.data.body)

          this.setCampaignBanners(response.data.body)
        })
    },
    getCampaigns2() {
      useJwt.campaigns2()
        .then(response => {
          this.$store.dispatch('app/setCampaigns', response.data.body)

          this.setCampaignBanners(response.data.body)
        })
    },
    isRunningAsInstalledApp() {
      // iOS Safari için standalone modu kontrolü (iOS 13 ve altı)
      const isIOSStandalone = window.navigator.standalone === true

      // Modern tarayıcılar için display-mode medya sorgusu
      const isDisplayModeStandalone = window.matchMedia('(display-mode: standalone)').matches

      // PWA'nın "minimal-ui" modunda çalışıp çalışmadığını kontrol etme
      const isDisplayModeMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches

      // PWA'nın "fullscreen" modunda çalışıp çalışmadığını kontrol etme
      const isDisplayModeFullscreen = window.matchMedia('(display-mode: fullscreen)').matches

      // Manifest'te display:browser ayarı olmadığı sürece
      // yukarıdaki modlardan herhangi biri, PWA olarak çalıştığını gösterir
      return isIOSStandalone || isDisplayModeStandalone || isDisplayModeMinimalUI || isDisplayModeFullscreen
    },
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    openPopup(campaign) {
      if (!campaign) return

      if (campaign.bannerAction === 'popup') {
        if (campaign.popupLayout === 'popup-with-user-1') {
          this.modalFlow2 = true
          this.modalFlow2Data = {
            ...campaign,
          }
        } else if (campaign.popupLayout === 'popup-premium') {
          this.modalBoostFlow = true
          this.modalBoostFlowData = {
            ...campaign,
          }

        }
      }
    },
    setCampaignBanners(campaigns) {
      if (Array.isArray(campaigns)) {
        try {
          this.bannerWithUser1 = campaigns.filter(campaign => {
            return campaign.bannerLayout === 'banner-with-user-1'
                && Array.isArray(campaign.displayAreas) && campaign.displayAreas.includes('banner')
          })

          if (this.bannerWithUser1 && this.bannerWithUser1.length > 0) {
            this.bannerWithUser1.forEach(banner => {
              // Displayed isteği gönder
              if (banner.campaignId && ['index', 'search-users', 'new-users', 'popular-users', 'video-call-users', 'for-you', 'near-by', 'online-users', 'moments'].includes(this.$route.name)) {
                useJwt.campaignsDisplayed({ campaignId: banner.campaignId })
              }

              // Her bir banner'ın sayacını kontrol edip, varsa ve 0'dan büyükse değerini bir azaltıyoruz.
              if ((typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) || (typeof banner.paywallCounter === 'number' && banner.paywallCounter > 0)) {
                if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                  banner.remainingCounter *= 60
                }
                banner.paywallCounter *= 60
                setInterval(() => {
                  if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                    banner.remainingCounter -= 1
                  }
                  banner.paywallCounter -= 1
                }, 1000)
              }
            })
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          this.bannerChat = campaigns.filter(campaign => {
            return campaign.bannerLayout === 'banner-chat'
                && Array.isArray(campaign.displayAreas) && campaign.displayAreas.includes('banner')
          })

          if (this.bannerChat && this.bannerChat.length > 0) {
            this.bannerChat.forEach(banner => {
              if (banner.campaignId && ['index', 'search-users', 'new-users', 'popular-users', 'video-call-users', 'for-you', 'near-by', 'online-users', 'moments'].includes(this.$route.name)) {
                useJwt.campaignsDisplayed({ campaignId: banner.campaignId })
              }

              // Her bir elemanın sayacını kontrol edip, varsa ve 0'dan büyükse değerini azaltıyoruz.
              if ((typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) || (typeof banner.paywallCounter === 'number' && banner.paywallCounter > 0)) {
                if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                  banner.remainingCounter *= 60
                }
                banner.paywallCounter *= 60
                setInterval(() => {
                  if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                    banner.remainingCounter -= 1
                  }
                  banner.paywallCounter -= 1
                }, 1000)
              }
            })
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          this.banner1 = campaigns.filter(campaign => {
            return campaign.bannerLayout === 'banner-1'
                && Array.isArray(campaign.displayAreas) && campaign.displayAreas.includes('banner')
          })

          // Eğer en az bir banner bulunduysa (array'in uzunluğu 0'dan büyükse) devam et.
          if (this.banner1 && this.banner1.length > 0) {
            this.banner1.forEach(banner => {
              if (banner.campaignId && ['index', 'search-users', 'new-users', 'popular-users', 'video-call-users', 'for-you', 'near-by', 'online-users', 'moments'].includes(this.$route.name)) {
                useJwt.campaignsDisplayed({ campaignId: banner.campaignId })
              }

              // Her bir banner objesinin remainingCounter'ı var mı ve sayı mı diye kontrol edilir.
              if ((typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) || (typeof banner.paywallCounter === 'number' && banner.paywallCounter > 0)) {
                if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                  banner.remainingCounter *= 60
                }
                banner.paywallCounter *= 60
                setInterval(() => {
                  if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                    banner.remainingCounter -= 1
                  }
                  banner.paywallCounter -= 1
                }, 1000)
              }
            })
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          // Koşula uyan tüm 'banner-premium' kampanyaları bir dizi olarak atanır.
          this.bannerPremium = campaigns.filter(campaign => {
            return campaign.bannerLayout === 'banner-premium'
                && Array.isArray(campaign.displayAreas) && campaign.displayAreas.includes('banner')
          })

          if (this.bannerPremium && this.bannerPremium.length > 0) {
            // Bu sayede her bir banner için ayrı interval oluşturmanın önüne geçilir.
            this.bannerPremium.forEach(banner => {
              if (banner.campaignId && ['index', 'search-users', 'new-users', 'popular-users', 'video-call-users', 'for-you', 'near-by', 'online-users', 'moments'].includes(this.$route.name)) {
                useJwt.campaignsDisplayed({ campaignId: banner.campaignId })
              }

              // Her bir banner objesi için sayacın varlığını, türünü ve değerini kontrol ediyoruz.
              if ((typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) || (typeof banner.paywallCounter === 'number' && banner.paywallCounter > 0)) {
                if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                  banner.remainingCounter *= 60
                }
                banner.paywallCounter *= 60
                setInterval(() => {
                  if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                    banner.remainingCounter -= 1
                  }
                  banner.paywallCounter -= 1
                }, 1000)
              }
            })
          }
        } catch (e) {
          // console.log(e);
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.boho-area-1 {
  background-color: #B03CF2;
  background-image: url("~@/assets/images/bg/purple-diamond-bg.png");
  background-repeat: no-repeat;
  background-position: center center;
  padding: 14px;
  border-radius: 14px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 800px;
  max-width: 95%;

  .boho-area-1__title {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 4px;
  }

  .boho-area-1__text {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 4px;
    border-bottom: 2px solid rgba(96, 179, 237, 0.99);
  }

  .boho-area-1__button {
    padding: 8px 12px;
    border-radius: 16px;
    //background-color: #fdfdfd !important;
    background: linear-gradient(90deg, rgba(233,231,236,1) 0%, rgb(198, 165, 246) 100%);
    transition: all .2s ease-in-out;
    color: #3F1186 !important;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .boho-area-1__button:hover {
    background-color: #f6edf8 !important;
    transition: all .2s ease-in-out;
  }

  .boho-area-1__button_counter {
    padding: 8px 12px;
    border-radius: 16px;
    background-color: #fdfdfd !important;
    color: #3F1186 !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
  }
}

.add-main-screen {
  display: none;
  position: relative;
  padding: 10px;
  text-align: center;
  height: 110px;
  width: 105%;
  margin-left: -2.5%;
  border-radius: 10px;
  background: url('~@/assets/images/bg/add-main-screen-bg.jpg') center center no-repeat;
  background-size: contain;
  margin-bottom: 8px;
  flex-direction: column;
  align-items: center;

  .banner-counter {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    left: 0;
    top: 10px;
    padding: 2px 22px;
    border-radius: 12px;
    background: #9327FF;
    color: #fff;
    font-size: 10px;
  }

  p {
    font-family: 'Lexend Deca', sans-serif;
    color: #fff;
    margin-bottom: 1px;
    font-size: 12px !important;
    font-weight: 700 !important;
  }

  @media (max-width: 768px) {
    display: flex;
  }

  button {
    font-size: 14px !important;
    padding: 4px 24px !important;
  }
}

.campaign-banner-container {
  width: 100%;
  display: flex;
  justify-content: center;
  .campaign-banner {
    display: flex;
    position: relative;
    padding: 10px;
    text-align: center;
    height: 110px;
    width: 420px;
    max-width: 105%;
    margin-left: -2.5%;
    border-radius: 10px;
    background: url('~@/assets/images/bg/add-main-screen-bg.jpg') center center no-repeat;
    background-size: contain;
    margin-bottom: 8px;
    flex-direction: column;
    align-items: center;

    .banner-counter {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 3px;
      left: 0;
      top: 10px;
      padding: 2px 22px;
      border-radius: 12px;
      background: #9327FF;
      color: #fff;
      font-size: 10px;
    }

    p {
      font-family: 'Lexend Deca', sans-serif;
      color: #272727;
      margin-bottom: 2px;
    }
    p:first-of-type {
      font-size: 13px !important;
      font-weight: 500 !important;
    }
    p:last-of-type {
      font-size: 17px !important;
      font-weight: bold !important;
      margin-bottom: 8px;
    }

    button {
      font-size: 14px !important;
      padding: 4px 24px !important;
    }
  }
}

.new-paywall1-container {
  width: 440px;
  max-width: 100% !important;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #600032, #000000);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  @media screen and (max-width: 440px) {
    width: 375px;
  }
  .new-paywall1-counter {
    font-family: 'Poppins', sans-serif !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    left: 0;
    bottom: 0;
    padding: 4px 24px 4px 12px;
    background: linear-gradient(to right, #FFDB6C, #EB944700);
    color: #000;
    font-size: 10px;
    font-weight: bold;
    z-index: 2;
    border-bottom-left-radius: 12px;
  }
  .new-paywall1 {
    display: flex;
    position: relative;
    padding: 6px 16px;
    text-align: center;
    height: 110px;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #fff;
      margin-bottom: 2px;
      font-size: 12px !important;
      font-weight: 700 !important;
    }

    .new-paywall1-button {
      background-color: #fff;
      color: #5E0131;
      border-radius: 16px;
      font-size: 10px !important;
      font-weight: bold;
      padding: 8px 24px !important;
      margin-bottom: 24px;
    }
  }
}

.new-paywall2-container {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #222222, #000000);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  @media screen and (max-width: 440px) {
    width: 375px;
  }
  .new-paywall2 {
    display: flex;
    position: relative;
    padding: 6px 16px;
    text-align: center;
    height: 110px;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #9935EF;
      margin-bottom: 2px;
      font-size: 15px !important;
      font-weight: 700 !important;
      text-align: center;
    }

    .new-paywall2-button {
      background-color: #fff;
      color: #B530EC;
      border-radius: 16px;
      font-size: 13px !important;
      font-weight: bold;
      padding: 8px 24px !important;
      margin-bottom: 24px;
    }
  }
}

.new-paywall3-container {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #B430ED, #EF055E);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  @media screen and (max-width: 440px) {
    width: 375px;
  }
  .new-paywall3-counter {
    font-family: 'Poppins', sans-serif !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    left: 0;
    bottom: 0;
    padding: 4px 24px 4px 12px;
    background: linear-gradient(to right, #FFFFFF, #FFFFFF00);
    color: #000;
    font-size: 10px;
    font-weight: bold;
    z-index: 2;
    border-bottom-left-radius: 12px;
  }
  .new-paywall3 {
    display: flex;
    position: relative;
    padding: 6px 16px;
    text-align: center;
    height: 110px;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #fff;
      margin-bottom: 2px;
      font-size: 13px !important;
      font-weight: 700 !important;
    }

    .new-paywall3-button {
      background-color: #fff;
      color: #B530EC;
      border-radius: 16px;
      font-size: 14px !important;
      font-weight: bold;
      padding: 6px 24px !important;
      margin-bottom: 24px;
    }
  }
}

.new-paywall4-container {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #730C98, #000000);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  @media screen and (max-width: 440px) {
    width: 375px;
  }
  .new-paywall4-counter {
    font-family: 'Poppins', sans-serif !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    left: 0;
    bottom: 0;
    padding: 4px 24px 4px 12px;
    background: linear-gradient(to right, #FFDB6C, #EB944700);
    color: #000;
    font-size: 10px;
    font-weight: bold;
    z-index: 2;
    border-bottom-left-radius: 12px;
  }
  .new-paywall4 {
    display: flex;
    position: relative;
    padding: 6px 16px;
    text-align: center;
    height: 110px;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #fff;
      margin-bottom: 2px;
      font-size: 12px !important;
      font-weight: 700 !important;
      margin-right: 12px;
    }

    .new-paywall4-button-top {
      background: linear-gradient(to bottom, #DB34F3, #7F1E8D);
      color: #fff;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      font-size: 11px !important;
      font-weight: bold;
      padding: 4px 12px !important;
      margin-bottom: 0 !important;
      width: 70px;
    }
    .new-paywall4-button {
      background-color: #fff;
      color: #730C97;
      border-radius: 16px;
      font-size: 11px !important;
      font-weight: bold;
      padding: 8px 20px !important;
      margin-bottom: 24px;
    }
  }
}

.instructions {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }

  p {
    font-size: 12px;
    font-weight: 400;
    color: #000;
    text-align: center;
    margin-bottom: 8px;

    &.title {
      font-size: 14px;
      font-weight: 700;
    }

  .instruction-top {
    display: flex;
    flex-direction: column;
    }
  }

  .instruction-bottom {
    display: flex;
    justify-content: space-between;
    gap: 8px; // divler arasında 8px boşluk

    > div {
      flex: 1; // eşit genişlikte olmaları için
      display: flex;
      flex-direction: column; // resimlerin alt alta olması için
      align-items: center;

      img, // Standart img etiketleri için
      .b-img { // b-img bileşenleri için
        width: 100%;
        margin-bottom: 8px; // resimler arasında boşluk

        &:last-child {
          margin-bottom: 0; // en alttaki resimde alt margin olmasın
        }
      }
    }
  }
}

.carousel {
  height: 100px;

  .carousel-item {
    height: 100px;
  }
}
</style>

<style lang="scss">
.modal-content {
  border-radius: 16px !important;
}
.congrats-modal {
  padding: 0 !important;

  .congrats {
    background: url('~@/assets/images/add-main-screen/congrats-bg.png') center center no-repeat;
    background-size: cover;
    padding: 16px;
    text-align: center;
    height: 370px;
    width: 100%;
    border-radius: 16px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h4 {
      font-family: 'Inter', sans-serif;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      color: #000;
    }
  }
}
.carousel-caption {
  position: relative !important;
  bottom: unset !important;
  left: unset !important;
  right: unset !important;
  padding-top: 0 !important;
}
.carousel-control-prev, .carousel-control-next {
  width: unset !important;
  z-index: 10;
}
.carousel-control-prev-icon, .carousel-control-next-icon {
  background-color: #c5c6cc;
}
#banner-carousel {
  &.carousel {
    width: 100% !important;
    display: flex;
    justify-content: center;
    .carousel-inner {
      width: unset !important;
    }
  }
  .carousel-control-next-icon {
  }
  .carousel-control-prev-icon {
  }
}
</style>
